<lib-dialog-layout-radial [dialogRef]="dialogRef" [btnText]="'global.next' | transloco">
  <ng-template #content>
    @if (data.audio?.url1x) {
      <lib-speaker-btn class="speaker-btn" [audioSrc]="data.audio.url1x"></lib-speaker-btn>
    }
    <p [innerHTML]="data.html | safe: 'html'"></p>
  </ng-template>

  <ng-template #actions>
    <div class="actions-container">
      <button (click)="close()" class="btn secondary w-md h-lg">{{ 'global.done' | transloco }}</button>
    </div>
  </ng-template>
</lib-dialog-layout-radial>
